var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsCulet = function SvgMetricsCulet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.296 25.474h-6.592L5.304 7.919h37.392zm-6.516 3.844h1v10.764h-1zm5.761 0h1v10.764h-1zM5.359 34.199h7.704v1H5.359z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.123 34.699-9.949 4.066 2.36-4.066-2.36-4.064zM42.641 34.7H27.877M34.937 34.199h7.704v1h-7.704z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.877 34.699 9.95-4.065-2.361 4.065 2.361 4.065z"
  })))));
};
export default SvgMetricsCulet;